import { useQuery } from 'convex/react';
import type { FunctionReturnType } from 'convex/server';
import { api } from '@aeon-karaoke/cloud-convex';

export type LegalPages = NonNullable<FunctionReturnType<typeof api.legal.pages>>;

/** The terms and privacy URLs the deployment names: undefined while loading,
 * null on a deployment that has not set `LEGAL_BASE_URL`. No account needed,
 * so the sign-in line reads it. */
export function useLegalPages() {
  return useQuery(api.legal.pages, {});
}
